<div *transloco="let t; read:'permit'" class="root">
    <div class="root__table">
        <div class="root__header">
            <div class="root__header__substance">{{ t("gasfreeCert.substanceColumn") }}</div>
            <div class="root__header__value">{{ t("gasfreeCert.measuredValueColumn") }}</div>
        </div>
        <ng-container *ngIf="form" [formGroup]="form">
            <ng-container formArrayName="measurements">
                <div *ngFor="let material of materials; let i = index" class="root__row" [formGroupName]="i">
                    <div class="root__row__substance">
                        <span class="root__row__substance__name">{{ material.name }}</span>
                        <button
                            type="button"
                            class="root__row__substance__info"
                            [attr.aria-label]="t('gasfreeCert.materialInfoModal.open', { materialName: material.name })"
                            (click)="openMaterialInfo(material)">
                        </button>
                    </div>
                    <div class="root__row__value">
                        <button type="button" class="root__row__decrement" (click)="decrementValue(material.flammableMaterialId)">−</button>
                        <input
                            formControlName="value"
                            type="number"
                            class="root__row__input"
                            [ngClass]="{
                                'root__row__input--within-limit': isWithinMaxConcentration(material),
                                'root__row__input--above-limit': isAboveMaxConcentration(material)
                            }" />
                        <button type="button" class="root__row__increment" (click)="incrementValue(material.flammableMaterialId)">+</button>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>
